export default "__VITE_ASSET__MtOj7fG___"